import { Fragment } from 'react';

import useStatus from './UseStatus';

import CertificationHeader from '../../../../officialsTrackingSystem/certificationApplication/CertificationHeader';

import Headings from '@usas/ui-web/components/headings/Headings';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const CertificationHeaderForOlderExistingCerts = ({ position }) => (
  <Fragment>
    <div className="col-xs-12 col-sm-6">
      {position.effectiveDate && (<p className={global.HeaderText}>
        <strong>Date Initiated:</strong>&nbsp;{formatDate(position.effectiveDate)}
      </p>)}
    </div>
    <div className="col-xs-12 col-sm-6">
      <p className={global.HeaderText}>
        <strong>Position:</strong>&nbsp;{position.positionTypeName}
      </p>
    </div>
    <div className="col-xs-12 col-sm-6">
      <p className={global.HeaderText}>
        <strong>Level:</strong>&nbsp;{position.levelName}
      </p>
    </div>
    <div className="col-xs-12 col-sm-6">
      <p className={global.HeaderText}>
        <strong>Application Status:</strong>&nbsp;{position.status || ''}
      </p>
    </div>
  </Fragment>
)

const Status = () => {
  const { personPositionCertificationProgressionId, certificationPublicNote, publicNotes, position, onCancelClicked, ruleData,
    positionCertificationProgression } = useStatus();

  return (
    <>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <Headings.H3>National Certification Application History</Headings.H3>
        </div>
      </div>
      {personPositionCertificationProgressionId !== Constants.DEFAULT_ID &&
        <CertificationHeader positionCertificationProgression={positionCertificationProgression} showApplicationStatus={true} />}
      <div className="row">
        {personPositionCertificationProgressionId === Constants.DEFAULT_ID &&
          <CertificationHeaderForOlderExistingCerts position={position} />}
        <div className="col-xs-12">
          <p className={global.HeaderText}>
            <strong>Reviewer Notes:</strong>&nbsp;{!publicNotes && !certificationPublicNote ? 'None Provided' : `${certificationPublicNote || ''}${certificationPublicNote ? '.' : ''} ${publicNotes || ''}`}
          </p>
        </div>
      </div>
      {ruleData?.positionCertificationRule && personPositionCertificationProgressionId !== Constants.DEFAULT_ID && (
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12">
            <div dangerouslySetInnerHTML={{ __html: ruleData?.positionCertificationRule }} />
          </div>
        </div>
      )}

      <div className="row usas-extra-top-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <SecondaryButton type="button" onClick={onCancelClicked}>Back</SecondaryButton>
        </div>
      </div>
    </>
  );
};

export default Status;